import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PinterestSVG = function PinterestSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M30 16a14 14 0 00-28 0c0 .41 0 .82.06 1.22l.06.46q0 .39.12.78l.09.52.2.75.27.86c.07.25.14.41.22.6l.27.61.23.48.31.59.28.45q.3.48.63.93a5.2 5.2 0 00.35.47c.13.17.28.33.43.5l.35.39c.16.16.31.32.48.47l.36.34.54.46.12.09a13.17 13.17 0 001.5 1l.16.1c.27.15.54.3.82.43l.17.09c.3.13.6.27.91.39A12.67 12.67 0 0111 25c.27-1.05 1.67-7 1.67-7a4.92 4.92 0 01-.44-2.1c0-1.92 1.14-3.41 2.54-3.41 1.22 0 1.75.87 1.75 2s-.79 3-1.14 4.64a2 2 0 001.46 2.48 2.28 2.28 0 00.64.06c2.45 0 4.37-2.63 4.37-6.39a5.56 5.56 0 00-5.42-5.7H16a6 6 0 00-6.29 5.7v.34a5.54 5.54 0 001.05 3.24.8.8 0 01.09.43c-.09.44-.35 1.4-.35 1.58-.18.26-.35.35-.61.17-1.75-.78-2.8-3.41-2.8-5.42 0-4.38 3.23-8.49 9.27-8.49 4.9 0 8.66 3.5 8.66 8.05C25 20 22 24 17.75 24a3.89 3.89 0 01-3.24-1.57l-.87 3.32a15.87 15.87 0 01-1.75 3.67A14 14 0 0016 30a14 14 0 0014-14z"
  }));
};
PinterestSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PinterestSVG);